import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogPercentComplete } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogCurrentItemIndex } from '@/redux/modules/console';

type Props = {
    catalogId: number;
    className?: string;
};

export const CatalogCardProgressBar = ({ catalogId, className }: Props) => {
    const currentItemIndex = useAppSelector((state) => getLiveCatalogCurrentItemIndex(state, catalogId));
    const percent = useAppSelector((state) => getCatalogPercentComplete(state, catalogId, currentItemIndex));
    return (
        <div className={cn('h-1 w-full bg-border-secondary', className)}>
            <div
                className="h-1 bg-critical-400 transition-all duration-200 ease-in"
                data-testid="catalog-card-progress-bar-inner"
                style={{ width: `${Math.max(2.5, percent)}%` }}
            />
        </div>
    );
};
